import React from 'react';
import { Waves, Coffee, Mountain, MapPin } from 'lucide-react';
import { IMG, BRAND } from '../lib/butterstone';

const FEATURES = [
  { icon: Waves, title: 'Riverside Living', text: 'A river flows right through our estate — wade in, picnic on the banks or simply listen.' },
  { icon: Coffee, title: 'Coffee Estate', text: 'Wander through a working coffee plantation wrapped in pepper vines and shade trees.' },
  { icon: Mountain, title: 'Valley Viewpoint', text: 'A dedicated viewpoint opening onto the layered ridges of the Western Ghats.' },
  { icon: MapPin, title: 'Waterfall Nearby', text: 'Magajahalli Abbi Falls is just 300 metres from the property gate.' },
];

const AboutSection = () => (
  <section id="about" className="section-pad bg-[#F6F5EF]" data-testid="about-section">
    <div className="max-w-7xl mx-auto px-5 md:px-8 grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">
      <div className="relative">
        <img src={IMG.streamForest} alt="Butterstone estate" className="rounded-lg w-full h-[300px] md:h-[440px] object-cover" />
        <img src={IMG.coffeeAerial} alt="Coffee estate" className="hidden md:block absolute -bottom-10 -right-6 w-52 h-64 object-cover rounded-lg border-8 border-[#F6F5EF] shadow-xl" />
      </div>
      <div>
        <span className="overline">About the property</span>
        <h2 className="font-serif text-4xl md:text-6xl mt-4">A scenic river valley in Sakleshpur</h2>
        <p className="text-[#3A4A3E] mt-5 leading-relaxed">
          {BRAND.name}, by the {BRAND.group}, is a premium riverside property set amidst the Western Ghats of Sakleshpur. A river winds through a sprawling coffee estate, opening onto a viewpoint over the valley — a true riverside experience, minutes from Magajahalli Abbi Falls.
        </p>
        <p className="text-[#3A4A3E] mt-3 leading-relaxed">
          Between the pool, the 100 m river zipline, rope courses and indoor games, there is room for adventure and for absolute stillness.
        </p>
        <div className="grid sm:grid-cols-2 gap-5 mt-8">
          {FEATURES.map((f, i) => (
            <div key={i} className="flex gap-3">
              <div className="w-11 h-11 rounded-full bg-[#EAF0E4] flex items-center justify-center flex-shrink-0"><f.icon size={20} className="text-[#2F5233]" /></div>
              <div>
                <p className="font-semibold text-[#1E3226]">{f.title}</p>
                <p className="text-sm text-[#5E6E60] leading-snug">{f.text}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  </section>
);

export default AboutSection;
